






import { Component, Prop, Vue } from "vue-property-decorator";
import CzPage from "../cz/CzPage.vue";

@Component({
  components: { CzPage },
})
export default class ProgramPage extends Vue {
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: [String, Object], default: "" }) backTo!: string | object;
  @Prop({ type: String, default: "" }) backLabel!: string;
  @Prop({ type: String, default: "" }) empty!: string;
}
